// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant
import { SETTINGS_RENTAL_API } from "@/constant/apiSettings";
import { POPUP_ID } from "@/constant/baseConstant";
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

export default {

    extends: baseRentalService,

    data() {

        return {
            renameForm: {
                newName: '',
            },
            rules: {
                newName: [
                    {
                        required: true,
                        message: this.$t('renameImageModal.validationRequiredName'),
                        trigger: "blur"
                    },
                ],
            },
        };
    },

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    watch: {
        targetImage: function (newVal, oldVal) {
            this.renameForm.newName = newVal.name;
        }
    },

    mounted() {
    },

    methods: {

        // Close this pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.RENAME_IMAGE);
        },

        //#region Rename image 
        rename() {
            this.$refs['renameForm'].validate(valid => {
                if (valid) {
                    this.feedStatusLoading(API_CALL_STATUS.LOADING);
                    setTimeout(() => {
                        let data = {
                            newName: this.renameForm.newName,
                            machineId: this.targetImage.id,
                            deviceInformation: JSON.stringify(this.getInformationClient())
                        }
                        api.baseRequest(SETTINGS_RENTAL_API.RENAME_IMAGE, data)
                            .then(() => {
                                EventBus.$emit("processingEventRental", { event: "isLoadingElement", data: [this.targetImage.id] });
                                EventBus.$emit("processingEventRental", { event: "autoRefresh" });
                                this.closeThisPopup();
                                this.notificationSuccess(
                                    this.$t('renameImageModal.successTitle'),
                                    this.$t('renameImageModal.successMessage', { id: this.targetImage.id, name: this.renameForm.newName })
                                );
                                this.feedStatusLoading(API_CALL_STATUS.SUCCESS);
                            })
                            .catch(error => {
                                this.processCatchApiRequest(error, this.$t('renameImageModal.failedMessage'))
                            });
                    }, this.smoothTimeOut);
                } else {
                    return false;
                }
            });
        },
        //#endregion 
    },
}